import { Link, useLocation } from 'react-router-dom'
import { useT } from '@/i18n/I18nProvider'

export function NotFoundPage() {
  const t = useT()
  const location = useLocation()
  return (
    <div className="min-h-full grid place-items-center p-6">
      <div className="max-w-md text-center">
        <p className="text-xs opacity-70 mb-2">404</p>
        <h1 className="text-2xl font-semibold mb-2">{t('not_found.title')}</h1>
        <p className="text-sm opacity-70 mb-4">{t('not_found.body')}</p>
        <p className="text-xs opacity-60 mb-6 font-mono break-all">{location.pathname}</p>
        <Link
          to="/"
          className="px-4 py-2 rounded text-sm font-medium inline-block"
          style={{ background: 'var(--color-accent)', color: 'white' }}
        >
          {t('not_found.back')}
        </Link>
      </div>
    </div>
  )
}
